var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pipelinesEnabled)?_c('DetailWithPipelines',{attrs:{"referral-id":_vm.referralId}}):_c('DetailVanilla',{attrs:{"referral-id":_vm.referralId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }